import home from './home';
import cart from './cart'
import address from './address'
import bookmark from './bookmark'
import profile from './profile'
import auth from './auth'
import price from './price'
import credit from './credit'
import order from './order'
import deposit from './deposit'
import product from './product'
import bank from './bank'

export default {
  home,
  cart,
  address,
  bookmark,
  profile,
  auth,
  price,
  credit,
  order,
  deposit,
  product,
  bank
}